module.exports = __webpack_public_path__ + "img/type4_uncheck1.0d289711.png";